export default __webpack_public_path__ + "static/media/isa.cf377711.svg";